import { Button, Center, Image, Stack, Text, Title } from '@mantine/core';
import { Link } from '@tanstack/react-router';

import imgNotFound from '@shared/img/404/page-not-found.svg';

export const NotFound = () => {
  if (import.meta.env.MODE_FEATURE_FLAG_REDESIGN_MANTINE !== 'on') {
    return (
      <div className='account'>
        <div className='account__wrapper'>404 — page not found</div>
      </div>
    );
  }

  return (
    <Center mih='100vh' p='xl'>
      <Stack gap='lg' align='center'>
        <Image src={imgNotFound} alt='' w={332} h={160} fit='contain' />
        <Stack gap='sm' align='center' maw={560}>
          <Title order={3} ta='center'>
            Page not found
          </Title>
          <Text size='xl' ta='center'>
            We can't find the page you're looking for. It may have been moved or
            deleted
          </Text>
        </Stack>
        <Button
          w={332}
          renderRoot={(props) => <Link to='/dashboard' {...props} />}
        >
          Back to dashboard
        </Button>
      </Stack>
    </Center>
  );
};
